import React from 'react';
import './Card.css';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import GroupsIcon from '@mui/icons-material/Groups';
import CreateIcon from '@mui/icons-material/Create';
import BiotechIcon from '@mui/icons-material/Biotech';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';


import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';     // fisica -- azul
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';               // quimica -- roxo
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';                 // geografia
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined'; // historia

// BIO: verde
// QUI: roxo
// FIS: laranja
// MAT: vermelho
// RED: ciano
// POR: azul
// HIS: amarelo
// GEO: marrom

const iconStyles = {

    humanas: { fontSize: 45, color: '#FF9800' },   
    natureza: { fontSize: 45, color: '#4CAF50' },  
    linguagens: { fontSize: 45, color: '#336699' }, 
    matematica: { fontSize: 45, color: '#E53935' },
    redacao: { fontSize: 45, color: '#5fbec4' },

    fisica: { fontSize: 45, color: '#FF9800' },
    quimica: { fontSize: 45, color: '#8E44AD' },
    geografia: { fontSize: 45, color: '#A0522D' },
    historia: { fontSize: 45, color: '#fdf063' }
    
};

function Card({ title, info, icon, unavailable, subject }) {
    const renderIcon = () => {
        switch (icon) {
            case 'groups':
                return <GroupsIcon className='icon humanas' style={iconStyles.humanas} />;
            case 'bio':
                return <BiotechIcon className='icon natureza' style={iconStyles.natureza} />;
            case 'chat':
                return <QuestionAnswerIcon className='icon linguagens' style={iconStyles.linguagens} />;
            case 'functions':
                return <CalculateOutlinedIcon className='icon matematica' style={iconStyles.matematica} />;
            case 'create':
                return <ArticleOutlinedIcon className='icon redacao' style={iconStyles.redacao} />;

            case 'fisica':
                return <RocketLaunchOutlinedIcon className='icon fisica' style={iconStyles.fisica} />;
            
            case 'quimica':
                return <ScienceOutlinedIcon className='icon quimica' style={iconStyles.quimica} />;
            
            case 'geografia':
                return <PublicOutlinedIcon className='icon geografia' style={iconStyles.geografia} />;
            
            case 'historia':
                return <AccountBalanceOutlinedIcon className='icon historia' style={iconStyles.historia} />;

            default:
                return null;
        }
    };

    const renderTitle = () => {
        if (title === "Redação") {
            return (
                <>
                    Redação
                    <br /><br />
                </>
            );
        }
        return title;
    };

    // Determina a classe do cartão dependendo do que é passado
    const cardClass = () => {
        let baseClass = 'card';
        switch (icon) {
            case 'groups':
                baseClass += ' card-humanas';
                break;
            case 'bio':
                baseClass += ' card-natureza';
                break;
            case 'chat':
                baseClass += ' card-linguagens';
                break;
            case 'functions':
                baseClass += ' card-matematica';
                break;
            case 'create':
                baseClass += ' card-redacao';
                break;
            
            case 'fisica':
                baseClass += ' card-fisica';
                break;
            
            case 'quimica':
                baseClass += ' card-quimica';
                break;
            
            case 'geografia':
                baseClass += ' card-geografia';
                break;
            
            case 'historia':
                baseClass += ' card-historia';
                break;

            default:
                break;
        }
        // Adiciona a classe unavailable se não tiver a propriedade
        if (unavailable) {
            baseClass += ' unavailable card-inactive';
        }

        return baseClass;
    };

    return (
        <div className={cardClass()}>

<div className={`icon-container ${subject ? 'subject' : ''}`}>

                {renderIcon()}
            </div>



            {!subject && <p className='card-title'>{renderTitle()}</p>}
            {!subject && <p className='card-info'>{info}</p>}

            

            
            {subject && <p className='card-info-subject'>{info}</p>}
        </div>
    );
}

export default Card;